/**
 * Feature flags — single source of truth for phased / WIP UI.
 *
 * Local development (show everything):
 *   cp .env.example .env.local
 *   Set REACT_APP_SHOW_ALL_FEATURES=true
 *   npm start  (restart after .env changes)
 *
 * Granular toggles (override defaults without enabling all):
 *   REACT_APP_SHIFTIQ_ENABLED=true
 *   REACT_APP_LEAVE_NAV_ENABLED=true
 *   REACT_APP_STUB_NAV_ENABLED=true   → Academy, Portioning, Bonus Calc
 *
 * Production builds ignore .env.local; flags default to off unless set at build time
 * (see Dockerfile / Fly deploy args).
 */

function envTruthy(name) {
  const v = process.env[name];
  if (v == null || v === "") return false;
  return v === "true" || v === "1" || v === "yes";
}

/** Master switch for local feature work — enables ShiftIQ, leave nav, stub pages, admin headcount. */
export const SHOW_ALL_FEATURES = envTruthy("REACT_APP_SHOW_ALL_FEATURES");

/** ShiftIQ optimal schedule, timeline, vs-optimal, headcount admin tab, store switcher demand cards. */
export const SHIFTIQ_ENABLED =
  SHOW_ALL_FEATURES || envTruthy("REACT_APP_SHIFTIQ_ENABLED");

/** Main nav Leave page + People & Stores → Leave tab (balances / entitlements). */
export const LEAVE_NAV_ENABLED =
  SHOW_ALL_FEATURES || envTruthy("REACT_APP_LEAVE_NAV_ENABLED");

/** Academy, Portioning reference, Bonus calculator (WIP content). */
export const STUB_NAV_ENABLED =
  SHOW_ALL_FEATURES || envTruthy("REACT_APP_STUB_NAV_ENABLED");

const STUB_PAGE_IDS = ["academy", "portioning", "bonus"];

/** Page IDs hidden from the sidebar, the mobile menu, and matching admin tabs. */
export const NAV_HIDDEN_PAGE_IDS = new Set(
  [
    ...(STUB_NAV_ENABLED ? [] : STUB_PAGE_IDS),
    ...(LEAVE_NAV_ENABLED ? [] : ["leave"]),
  ]
);

if (process.env.NODE_ENV === "development") {
  const on = [];
  if (SHOW_ALL_FEATURES) on.push("SHOW_ALL_FEATURES");
  if (SHIFTIQ_ENABLED) on.push("SHIFTIQ");
  if (LEAVE_NAV_ENABLED) on.push("LEAVE_NAV");
  if (STUB_NAV_ENABLED) on.push("STUB_NAV");
  if (on.length) {
    // eslint-disable-next-line no-console
    console.info("[pg-ops features]", on.join(", "));
  }
}
